import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector, useStore } from 'react-redux'
import { useHistory } from 'react-router-dom'

import SaveIcon from '@mui/icons-material/Save'
import ClearIcon from '@mui/icons-material/Clear'
import DeleteIcon from '@mui/icons-material/Delete';
import LowPriorityIcon from '@mui/icons-material/LowPriority'
import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import PowerIcon from '@mui/icons-material/Power';
import PowerOffIcon from '@mui/icons-material/PowerOff';
import CheckIcon from '@mui/icons-material/Check';
// import { makeStyles } from '@mui/styles';

import { constants } from '../../Constants/constants'
import { put } from '../../helper/baseFetch'
import { getOne } from '../../helper/baseFetch'
import { setSurveyMapping, setSurveyMappingValue } from '../../actions/surveyMappingAction'
import { EditCreateDisplay } from '../../Component/EditCreateDisplay/EditCreateDisplay'
import { GlobalDialog } from '../../Component/GlobalDialog'
import { getContent } from '../../Component/EditCreateDisplay/EditUtil'
import { ProfileCodeSection } from '../Staff/StaffProfileCodeSection'
import { TempAutoSelectInput } from '../../Component/Input/TempAutoSelectInput'
import { SurveyListWithDrawer } from './SurveyListWithDrawer'

const resource = 'survey'

const labelsKeys = ['status']

export const SurveyMappingEdit = () => {

  const dispatch = useDispatch()
  const store = useStore()
  const params = useParams()
  const history = useHistory()

  const [showQueueTransferProfileCode, setShowQueueTransferProfileCode] = useState(false)
  const [ready, setReady] = useState(false)
  const [clear, setClear] = useState(true)
  const [dialog, setDialog] = useState({
    open: false,
    dialogActions: [],
  })
  const savedSurveyMapping = useSelector((state) => state.surveyMapping.ui.surveyMapping)

  const tabs = [
    {
      label: { resource: resource, key: 'info' },
      tabIndex: constants.RESTAURANT_SURVEY_SUB_TUB.SURVEY_MAPPING_LIST,
    },
  ]

  const tempMerchantUserEditList = [
    {
      type: constants.TYPE.TITLE,
      value: { resource: resource, key: '' },
      className: 'sub-title',
      labelEntries: Object.entries(savedSurveyMapping).filter(([key]) => labelsKeys.includes(key)),
      labelsDateKeys: [],
      translateValue: true
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'refCode' },
      value: savedSurveyMapping.refCode,
      variant: constants.STYLE.VARIANT.STANDARD,
      disabled: true,
      name: 'refCode',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'refType' },
      variant: constants.STYLE.VARIANT.STANDARD,
      value: savedSurveyMapping.refType,
      disabled: true,
      name: 'refType',
      isEndOfLine: true,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'surveyId' },
      type: constants.TYPE.FUNCTION,
      value: (
        <SurveyListWithDrawer
          resource={resource}
          resourceKey={'surveyId'}
          value={savedSurveyMapping.surveyId}
          onChangeInput={onChangeInput}
          restUrlId={params.id}
          clear={false}
        />
      ),
      variant: constants.STYLE.VARIANT.STANDARD,
      name: 'surveyId',
      isEndOfLine: true,
    },
    // {
    //   className: 'edit-create-input',
    //   size: constants.SIZE.SMALL,
    //   label: { resource: resource, key: 'refType' },
    //   type: constants.TYPE.FUNCTION,
    //   value: (
    //     <TempAutoSelectInput
    //       inputSetting={{
    //         label: { resource: resource, key: 'refType' },
    //         value: savedSurveyMapping.refType,
    //         selectValue: constants.CHOICES.SURVEY.REF_TYPE,
    //         name: 'refType',
    //         disableClearable: true,
    //         // helperText: validation.getErrMsg(validationConstants.KEY_STATUS),
    //       }}
    //       handleChange={onChangeInput}
    //     />
    //   ),
    //   isEndOfLine: false,
    // },
    {
      className: 'edit-create-input',
      variant: constants.STYLE.VARIANT.STANDARD,
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'serviceType' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'serviceType' },
            value: savedSurveyMapping.serviceType,
            selectValue: constants.CHOICES.SURVEY.SERVICE_TYPE,
            name: 'serviceType',
            disableClearable: true,
            // helperText: validation.getErrMsg(validationConstants.KEY_STATUS),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'surveyType' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'surveyType' },
            value: savedSurveyMapping.surveyType,
            selectValue: constants.CHOICES.SURVEY.SURVEY_TYPE,
            name: 'surveyType',
            disableClearable: true,
            // helperText: validation.getErrMsg(validationConstants.KEY_STATUS),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      variant: constants.STYLE.VARIANT.STANDARD,
      label: { resource: resource, key: 'mandatory' },
      type: constants.TYPE.FUNCTION,
      value: (
        <TempAutoSelectInput
          inputSetting={{
            label: { resource: resource, key: 'mandatory' },
            value: savedSurveyMapping.mandatory,
            selectValue: constants.CHOICES.SURVEY.MANDATORY,
            name: 'mandatory',
            disableClearable: true,
            // helperText: validation.getErrMsg(validationConstants.KEY_STATUS),
          }}
          handleChange={onChangeInput}
        />
      ),
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'startTimestamp' },
      type: constants.TYPE.DATETIME_LOCAL,
      value: savedSurveyMapping.startTimestamp,
      name: 'startTimestamp',
      isEndOfLine: false,
    },
    {
      className: 'edit-create-input',
      size: constants.SIZE.SMALL,
      label: { resource: resource, key: 'endTimestamp' },
      type: constants.TYPE.DATETIME_LOCAL,
      value: savedSurveyMapping.endTimestamp,
      name: 'endTimestamp',
      isEndOfLine: false,
    }
  ]

  const content = [
    {
      tab: tempMerchantUserEditList.map((inputSetting, index) => {
        let content = getContent(inputSetting, index, onChangeInput)
        return (
          <div className="edit-display-wrapper" key={index}>
            {content}
            {inputSetting.isEndOfLine && <div></div>}
          </div>
        )
      }),
      btn: true,
    }
  ]

  const bottomBtns = [
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'save' },
      onClick: onClickSave,
      className: 'margin-left-16',
      icon: <SaveIcon />,
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.PRIMARY,
      label: { key: 'clear' },
      disabled: false,
      onClick: onClickClear,
      className: 'margin-left-16',
      icon: <ClearIcon />,
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: savedSurveyMapping.status == 'A' ? constants.STYLE.ERROR : constants.STYLE.SUCCESS,
      icon: savedSurveyMapping.status == 'A' ? <PowerOffIcon /> : <PowerIcon />,
      label: { key: savedSurveyMapping.status == 'A' ? 'disabled' : 'enabled' },
      className: 'special-button-margin-left margin-right-16',
      onClick: () => toggleStatus(),
    },
    {
      variant: constants.STYLE.VARIANT.CONTAINED,
      color: constants.STYLE.ERROR,
      icon: <DeleteIcon />,
      label: { key: 'deleteBtn' },
      className: 'special-button margin-right-16',
      onClick: () => confirmToDelete(),
    },
  ]

  const onClickBackToEdit = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    onClickClear()
  }
  const onClickBackToList = () => {
    setDialog({
      open: false,
      dialogActions: [],
    })
    history.push(
      '/' +
      constants.PATH.SHOP.SYSTEM_GROUP_RESTAURANT +
      '/' +
      params.restUrlId +
      '/' +
      constants.RESTAURANT_TAB.SURVEY +
      '/' +
      constants.RESTAURANT_SURVEY_SUB_TUB.SURVEY_MAPPING_LIST
    )
  }

  function onChangeInput(name, e) {
    switch (name) {
      case 'startTimestamp':
      case 'endTimestamp':
        dispatch(setSurveyMappingValue(name, savedSurveyMapping, '', new Date(e).getTime()))
        break
      default:
        dispatch(setSurveyMappingValue(name, savedSurveyMapping, '', e))
    }
  }

  function onClickSave() {
    put(
      constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP + '/' + params.id,
      savedSurveyMapping,
      () => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: 'editSuccess' },
          dialogActions: [
            { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      undefined,
      store
    )
  }

  function onClickClear() {
    setClear(true)
  }

  function toggleStatus() {
    put(
      constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP_STATUS + '/' + params.id,
      {
        // status: savedSurveyMapping.status == 'A' ? 'D' : 'A'
        status: savedSurveyMapping.status == 'P' ? 'A' : 'P'
      },
      () => {
        setDialog({
          open: true,
          onClose: onClickBackToEdit,
          dialogContentText: { key: 'editSuccess' },
          dialogActions: [
            { label: { key: 'backEdit' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
            { label: { key: 'backList' }, onClick: onClickBackToList, icon: <LowPriorityIcon /> },
          ],
        })
        setClear(false)
      },
      undefined,
      store
    )
  }

  function confirmToDelete() {
    setDialog({
      open: true,
      onClose: onClickBackToEdit,
      dialogContentText: { key: 'deleteContent' },
      dialogActions: [
        { label: { key: 'cancelBtn' }, onClick: onClickBackToEdit, icon: <ArrowBackIcon /> },
        { label: { key: 'confirm' }, onClick: deleteSurvey, icon: <CheckIcon /> },
      ],
    })
    setClear(false)
  }

  function deleteSurvey() {
    put(
      constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP_STATUS + '/' + params.id,
      {
        status: 'D'
      },
      () => {
        onClickBackToEdit()
        setClear(false)
      },
      undefined,
      store
    )
  }

  useEffect(() => {
    if (clear === true) {
      getOne(
        constants.PATH.SURVEY.RESTAURANT_SURVEY_MAP + '/' + params.id,
        undefined,
        (payload) => {
          dispatch(setSurveyMapping(payload))
          setReady(true)
          setClear(false)
        },
        undefined,
        store
      )
    }
  }, [clear]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    ready && (
      <>
        <EditCreateDisplay
          code={savedSurveyMapping && savedSurveyMapping.id ? savedSurveyMapping.id : ''}
          resource={resource}
          tabs={tabs}
          content={content}
          onChangeInput={onChangeInput}
          bottomBtns={bottomBtns}
          display="edit"
        />
        {dialog && dialog.open && <GlobalDialog dialogInfo={dialog} />}
      </>
    )
  )
}
